import type { Technology } from '../../data/technologies'
import { TechnologyCard } from './TechnologyCard'

export function TechnologyGrid({ items, compact = false }: { items: Technology[]; compact?: boolean }) {
  return <div className={`tech-grid${compact ? ' tech-grid--secondary' : ''}`}>{items.map((item) => <TechnologyCard technology={item} compact={compact} key={item.id} />)}</div>
}
